import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TextField, Select } from 'redux-form-material-ui';

import {
  Field, change, Form, formValueSelector,
} from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { FORM_NAME, FORM_DEFINITION, USER_TYPE } from './index';
import { getAccountById, save } from '../../../redux/actions/accountActions';

import CPFNormalize from './../../normalize/CPFNormalize';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';


const formSelector = formValueSelector(FORM_NAME);
const mapStateToProps = state => ({
  accountData: state.accountReducer.accountData,
  accountId: state.accountReducer.accountId,
  companyList: state.accountReducer.companyList,
  values: formSelector(state, 'id', 'name', 'login', 'password', 'userTypeId', 'cpf', 'email', 'lstCompany'),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getAccountById,
  save,
}, dispatch);


export class AccountReduxForm extends Component {

  static propTypes = {

  };

  static defaultProps = {

  };

  constructor(props) {

    super(props);
    this.state = {
      selectedCompanies: [],
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.setFormValues = this.setFormValues.bind(this);

  }

  componentDidMount() {

    const { reset, accountId, get, getAccountById } = this.props;

    reset();

    if (accountId) getAccountById(accountId).then((data) => {

      let lstCompany = [];

      data.lstCompany.forEach((company) => {

        lstCompany.push(company.idCompany ? company.idCompany : company);

      });

      data.lstCompany = lstCompany;

      this.setFormValues(data);

    });


  }

  onSubmit(data) {

    const { save, dispatch } = this.props;

    return save(data).then(() => true, (errors) => {

      throw errors;

    });

  }

  setFormValues(values) {

    const { dispatch } = this.props;


    Object.keys(values).forEach((key) => {

      let value = '';
      switch (key) {

        case 'dateCreated':
          value = new Date(values[key]);
          break;


        default:
          value = values[key];

      }

      dispatch(change(FORM_NAME, key, value));

    });

  }

  updateCompanies = field => (event) => {

    this.setState({
      selectedCompanies: event.target.value,
    });

  }

  render() {

    const {
      submitting,
      handleSubmit,
      companyList,

    } = this.props;

    const {
      selectedCompanies,
    } = this.state;

    return (

      <div>
        <Form form={FORM_NAME} onSubmit={handleSubmit(this.onSubmit)}>

          <div>
            <Field
              name="name"
              component={TextField}
              label={I18n.t('fields.name')}
              fullWidth
              disabled={submitting}
            />

            <Field
              name="login"
              component={TextField}
              label={I18n.t('fields.login')}
              fullWidth
              disabled={submitting}
            />
            <Field
              name="password"
              component={TextField}
              label={I18n.t('fields.password')}
              fullWidth
              type="password"
              disabled={submitting}
            />


            <FormControl fullWidth>
              <InputLabel htmlFor="userTypeId">{I18n.t('fields.user_type')}</InputLabel>
              <Field
                name="userTypeId"
                component={Select}
                fullWidth
                disabled={submitting}

              >
                <MenuItem key={USER_TYPE.ADMINISTRATOR} value={USER_TYPE.ADMINISTRATOR}>{I18n.t(`enums.userType.${USER_TYPE.ADMINISTRATOR}`)}</MenuItem>
                <MenuItem key={USER_TYPE.OPERATOR} value={USER_TYPE.OPERATOR}>{I18n.t(`enums.userType.${USER_TYPE.OPERATOR}`)}</MenuItem>

              </Field>
            </FormControl>

            <Field
              name="email"
              component={TextField}
              label={I18n.t('fields.email')}
              fullWidth
              disabled={submitting}
              type="email"
            />

            <Field
              name="cpf"
              component={TextField}
              label={I18n.t('fields.cpf')}
              fullWidth
              normalize={CPFNormalize}
              disabled={submitting}
            />

            <FormControl fullWidth>
              <InputLabel htmlFor="lstCompany">{I18n.t('fields.company')}</InputLabel>
              <Field
                name="lstCompany"
                component={Select}
                fullWidth
                multiple
                type="select-multiple"
                disabled={submitting}
              >

                {companyList.map(company => (<MenuItem key={company.idCompany} value={company.idCompany}>{company.name}</MenuItem>))}


              </Field>
            </FormControl>

          </div>

        </Form>

      </div>
    );

  }
}


export default FORM_DEFINITION(
  connect(mapStateToProps, mapDispatchToProps)(AccountReduxForm),
);



// WEBPACK FOOTER //
// ./src/components/tracker/User/AccountReduxForm.js